<template>
  <div class="terms-dialog-wrapper">
    <!-- 弹窗遮罩层 -->
    <div class="dialog-mask" v-show="visible"></div>

    <!-- 弹窗主体 -->
    <div class="dialog-container" v-show="visible">
      <div class="dialog-header">📢 发送条款须知</div>
      <div class="dialog-content">
        请仔细阅读以下条款：<br/>
        1. <strong class="text-danger">禁止</strong>发送政府相关/黄赌毒/举报投诉/社会舆论/恐吓骚扰/威胁辱骂/破坏家庭/游戏中奖/银行快递等高风险内容，否则<strong class="text-danger">封号并不予退款</strong>；<br/>
        2. 请在收件人允许下情况下发送，部分内容可能会触发人工审核，请合理安排发送时间；<br/>
        注意：如发送违规信息我们将积极配合收件人或相关部门调查取证，网络非法外之地！
      </div>
      <div class="dialog-footer">
        <button class="btn-confirm" @click="handleConfirm">我已阅读并同意</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      // 保存原始body样式，用于精准恢复
      originBodyStyle: ''
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.disableBodyScroll();
      } else {
        this.enableBodyScroll();
      }
    }
  },
  methods: {
    // 同意按钮点击事件
    handleConfirm() {
      localStorage.setItem('agreedTerms', 'true');
      this.$emit('confirm');
    },
    // 禁止页面滚动（精准保存原始样式）
    disableBodyScroll() {
      // 保存body原始样式，避免覆盖自定义样式
      this.originBodyStyle = document.body.getAttribute('style') || '';
      // 保存当前滚动位置
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 仅添加必要的禁止滚动样式，不覆盖原有样式
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollTop}px`;
      document.body.style.left = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
      // 记录滚动位置
      document.body.setAttribute('data-scroll-top', scrollTop);
    },
    // 恢复页面滚动（精准还原原始样式）
    enableBodyScroll() {
      const scrollTop = document.body.getAttribute('data-scroll-top');
      // 关键修复：还原body原始样式，而非清空
      if (this.originBodyStyle) {
        document.body.setAttribute('style', this.originBodyStyle);
      } else {
        // 无原始样式时，逐个重置属性（避免清空所有样式）
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
      }
      // 恢复滚动位置
      if (scrollTop) {
        window.scrollTo(0, parseInt(scrollTop));
        document.body.removeAttribute('data-scroll-top');
      }
      // 清空保存的原始样式
      this.originBodyStyle = '';
    }
  },
  // 组件销毁时强制恢复滚动
  beforeDestroy() {
    this.enableBodyScroll();
  }
};
</script>

<style scoped>
.terms-dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  pointer-events: none; /* 关键：遮罩层外的区域可点击（仅弹窗内可交互） */
}

/* 遮罩层样式 */
.dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto; /* 遮罩层可拦截点击，但无关闭事件 */
  touch-action: none;
}

/* 弹窗主体 */
.dialog-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  pointer-events: auto; /* 弹窗内可交互 */
  touch-action: auto;
}

.dialog-header {
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  border-bottom: 1px solid #eee;
}

.dialog-content {
  padding: 16px;
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  margin: 0;
}

.text-danger {
  color: #f53f3f;
  font-weight: 500;
}

.dialog-footer {
  padding: 12px 16px;
  border-top: 1px solid #eee;
}

.btn-confirm {
  width: 100%;
  padding: 8px 0;
  background-color: #00D477;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-confirm:focus {
  outline: none;
}

.dialog-content * {
  margin: 0 !important;
  padding: 0 !important;
  line-height: inherit !important;
}
</style>